import React, { useState } from 'react';

// Global state for WhatsApp sign in/up mode
let globalWhatsAppMode = 'signIn';
const modeListeners = [];

const setGlobalWhatsAppMode = (mode) => {
  globalWhatsAppMode = mode;
  modeListeners.forEach(listener => listener(mode));
};

export const useWhatsAppMode = () => {
  const [mode, setMode] = useState(globalWhatsAppMode);

  React.useEffect(() => {
    const listener = (mode) => setMode(mode);
    modeListeners.push(listener);
    return () => {
      const index = modeListeners.indexOf(listener);
      if (index > -1) modeListeners.splice(index, 1);
    };
  }, []);

  return [mode, setGlobalWhatsAppMode];
};

export { setGlobalWhatsAppMode };
export default useWhatsAppMode;
